import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import SimplifiedSignup from '@/components/SimplifiedSignup';
import AnnualOfferConfig from '@/components/SimplifiedSignup/configs/AnnualOffer/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { shapeConfigForParams } from '@/components/SimplifiedSignup/Context/utils';
import { InitRequest } from '@/hooks/store';
import type { InitialServerState } from '@/store';
import { resolveCheckoutSessionsEnabled } from '@/utils/experiments/resolveCheckoutSessionsEnabled';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

type Props = {
	initialState: InitialServerState | null;
	isCheckoutSessionsEnabled: boolean;
};

const AnnualOfferPage = ({ isCheckoutSessionsEnabled }: Props) => {
	return (
		<Layout pageName="annual_offer" title="Calm - Annual Offer">
			<SimplifiedSignupContextProvider
				flowConfig={AnnualOfferConfig}
				isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
			>
				<SimplifiedSignup />
			</SimplifiedSignupContextProvider>
		</Layout>
	);
};

export default AnnualOfferPage;

export const getServerSideProps: GetServerSideProps<Props> = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.PRICES, InitRequest.USER],
		shapeConfigForParams(AnnualOfferConfig),
	);

	// Resolved server-side so the payment screen's first render already
	// knows the buyer's `www-checkout-sessions` bucket (see the enrollment
	// latch in PaymentElementsFormRefresh).
	const isCheckoutSessionsEnabled = await resolveCheckoutSessionsEnabled(initialState);

	return {
		props: {
			initialState,
			isCheckoutSessionsEnabled,
		},
	};
};
